import React from "react";
import { resetOrderState, GlobalStore } from "../../store/global/GlobalStore";
import { YouPaySection } from "../../components/Modal/instance/ConfirmTrade/YouPaySection";
import { YouReceiveSection } from "../../components/Modal/instance/ConfirmTrade/YouReceiveSection";
import { TradeDetailsSection } from "../../components/DetailsSection/TradeDetailsSection";
import { Amount } from "../../types/amount";
import { OrderStatus } from "../../types/orderStatus";
import { ProgressBar } from "../../components/ProgressBar/ProgressBar";
import order_failed from "../../img/trade-interface/order-error.png";
import "./OrderCompleted.css";
import { useTimedQuoteRefetch } from "../../hooks/useTimedQuoteRefetch";
import { ErrorSection } from "./sections/ErrorSection";
import { getErrorMessageFromOrderError } from "../../config/errorCodes";
import * as Sentry from "@sentry/browser";
import { ActionButtonContainer } from "./elements/ActionButtonContainer";

export interface OrderFailedProps {}

export const OrderFailed: React.FC<OrderFailedProps> = () => {
  const { forceRefresh } = useTimedQuoteRefetch();
  const orderStatus = GlobalStore.useState(s => s.orderStatus);
  const errorMessageFromOrderError = GlobalStore.useState(s => s.orderError);
  const { networkFee } = GlobalStore.useState(s => {
    return { networkFee: s.quote?.usdGasFee };
  });

  return (
    <>
      <div className="review-order">
        {/* TODO: Add Order error states */}
        <div className="col-12 text-center">
          <h5 className="w-100 text-center m-0 trade">Error with Trade</h5>
        </div>
        <div className="sp10"></div>
        <div className="col-12 text-center">
          <img src={order_failed} width={115} height={116} alt="Order failed" />
          <div className="sp12"></div>
        </div>
        <div className="sp12"></div>
        <div>
          <YouPaySection shouldDisplayLabel />
          <YouReceiveSection shouldDisplayLabel />
        </div>
        {!errorMessageFromOrderError && <div className="sp12"></div>}
        <ErrorSection
          error={
            errorMessageFromOrderError && getErrorMessageFromOrderError(errorMessageFromOrderError)
          }
        />
        <TradeDetailsSection
          networkFee={networkFee ?? Amount.ZERO}
          visible={orderStatus === OrderStatus.IN_PROGRESS}
        />
        <div className={"progress-bar-container"}>
          <ProgressBar step={4} />
        </div>
        <ActionButtonContainer>
          <button
            type="button"
            className="btn bebop-white-btn btn-lg btn-block button-font-size"
            onClick={resetOrderState}
          >
            Make Another Trade
          </button>
          <button
            type="button"
            className="btn btn-bebop-primary btn-lg btn-block text-white  button-font-size"
            onClick={() => {
              // We need to force refresh the quote
              forceRefresh()
                .then(() => {
                  GlobalStore.update(s => {
                    s.orderError = undefined;
                    s.signedMessage = undefined;
                    s.orderStatus = OrderStatus.REVIEW;
                  });
                })
                .catch(err => {
                  Sentry.captureException(`Could not force refresh quote after order faield`, {
                    extra: { e: err },
                  });
                });
            }}
          >
            Try again
          </button>
        </ActionButtonContainer>
      </div>
    </>
  );
};
